module.exports = __webpack_public_path__ + "5af4dc97fbc6eaeade0cc1e3b9a87f84.pdf";